export default __webpack_public_path__ + "static/media/list.830fcb19.svg";